module.exports = __webpack_public_path__ + "static/media/dropdown-icon.399b0784.svg";